export const TRANSACTION_ALL_LIST_REQUEST = 'TRANSACTION_ALL_LIST_REQUEST'
export const TRANSACTION_ALL_LIST_SUCCESS = 'TRANSACTION_ALL_LIST_SUCCESS'
export const TRANSACTION_ALL_LIST_FAIL = 'TRANSACTION_ALL_LIST_FAIL'

export const TRANSACTION_LAST_LIST_REQUEST = 'TRANSACTION_LAST_LIST_REQUEST'
export const TRANSACTION_LAST_LIST_SUCCESS = 'TRANSACTION_LAST_LIST_SUCCESS'
export const TRANSACTION_LAST_LIST_FAIL = 'TRANSACTION_LAST_LIST_FAIL'

export const TRANSACTION_TRASH_LIST_REQUEST = 'TRANSACTION_TRASH_LIST_REQUEST'
export const TRANSACTION_TRASH_LIST_SUCCESS = 'TRANSACTION_TRASH_LIST_SUCCESS'
export const TRANSACTION_TRASH_LIST_FAIL = 'TRANSACTION_TRASH_LIST_FAIL'

export const TRANSACTION_CREATE_REQUEST = 'TRANSACTION_CREATE_REQUEST'
export const TRANSACTION_CREATE_SUCCESS = 'TRANSACTION_CREATE_SUCCESS'
export const TRANSACTION_CREATE_FAIL = 'TRANSACTION_CREATE_FAIL'
export const TRANSACTION_CREATE_MESSAGE_CLEAR =
  'TRANSACTION_CREATE_MESSAGE_CLEAR'

export const TRANSACTION_DELETE_REQUEST = 'TRANSACTION_DELETE_REQUEST'
export const TRANSACTION_DELETE_SUCCESS = 'TRANSACTION_DELETE_SUCCESS'
export const TRANSACTION_DELETE_FAIL = 'TRANSACTION_DELETE_FAIL'
export const TRANSACTION_DELETE_MESSAGE_CLEAR =
  'TRANSACTION_DELETE_MESSAGE_CLEAR'
